<template>
    <header class="app-header">
        <app-title homeUrl='/' @goHome="goHome"></app-title>
        <!--<span class="admin-top-menu">-->
            <!--<router-link :to="projMgtPath" :class="{'atm-active': isProjActive()}">项目管理 </router-link>-->
            <!--<router-link :to="userActionPath" :class="{'atm-active': isUserActionActive()}">数据管理</router-link>-->
            <!--<router-link :to="templateManagementPath" :class="{'atm-active': templateManagementActive()}">模板管理</router-link>-->
        <!--</span>-->
        <app-logout></app-logout>
    </header>
</template>
<script>
    import appTitle from '@/views/layout/app-title';
    import appLogout from '@/views/layout/app-logout';
    export default {
        name: 'admin-header',
        components: {appTitle, appLogout},
        data () {
            return {
                projMgtPath: '/admin/projectManagement',
                userActionPath: '/admin/userAction',
                templateManagementPath: '/admin/templateManagement'
            };
        },
        methods: {
            isProjActive() {
                let path = this.$route.path;
                return ['/admin/projectManagement', '/admin/projectApproval'].indexOf(path) > -1;
            },
            isUserActionActive() {
                return  this.$route.path === this.userActionPath;
            },
            templateManagementActive() {
                return  this.$route.path === this.templateManagementPath;
            },
            goHome () {
                this.$emit('goHome');
            }
        }
    }
</script>